import styles from '../styles';
import { withStyles } from '@material-ui/core';
import StandardTextField from './StandardTextField';
import { CallOutlined, PersonOutlineOutlined } from '@material-ui/icons';
import SectionHeader from './SectionHeader';
import constants from '../../../Dispatch/RouteExecution/DriverPopUp/EditStopDialog/constants';
import { MAX_LENGTH_CONSTRAINTS } from '../../../Dispatch/RouteExecution/DriverPopUp/common/constants';
import { ALPHA_NUMERIC_REGEX_WITH_SPACING } from '../../../Dispatch/RouteExecution/constRegex';

const ContactDetails = ({
  classes,
  title,
  details,
  updateDetails,
  contactNameField = 'contactName'
}) => {
  const handleUpdate = (field) => (value) => {
    // Remove all non-digit characters for phone number
    const processedValue = field === 'phoneNumber' ? unmaskPhoneNumber(value) : value;
    updateDetails(field, processedValue);
  };

  const unmaskPhoneNumber = (value) => {
    return value.replace(/\D/g, '');
  };

  return (
    <div className={classes.contactDetailsContainer}>
      <SectionHeader title={title} />
      <div className={classes.contactDetailsSection}>
        <StandardTextField
          value={details[contactNameField] ?? ''}
          handleUpdate={handleUpdate(contactNameField)}
          placeholder="Enter name"
          startAdornment={<PersonOutlineOutlined />}
          inputProps={{
            maxLength: MAX_LENGTH_CONSTRAINTS.DELIVERY_PRO_FORM.RECEIVER_NAME,
            pattern: ALPHA_NUMERIC_REGEX_WITH_SPACING,
            title: '' 
          }}
          classes={{ container: classes.contactNameContainer }}
        />
        <StandardTextField
          value={details.phoneNumber}
          handleUpdate={handleUpdate('phoneNumber')}
          placeholder="Enter phone"
          startAdornment={<CallOutlined />}
          mask={constants.PHONE_NUMBER_MASK}
          error={details.errorInfo?.phoneNumber}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(ContactDetails);
